import { useNavigate } from 'react-router-dom';

interface CreateSpaceButtonProps {
  type: 'personal' | 'shared';
}

export const CreateSpaceButton = ({ type }: CreateSpaceButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to spaces page with createSpace view and type
    navigate(`/spaces?view=createSpace&type=${type}`);
  };

  // Icon based on type
  const icon = type === 'personal'
    ? (
      // Single person icon
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
    )
    : (
      // Group of people icon
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    );

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-sky-blue dark:hover:text-sky-blue hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors group"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
      <span>Create Space</span>
      {icon}
    </button>
  );
};
